import * as yup from "yup";
export const citySchema = requiredMessage => yup.string()
    .test(
        'is-valid-cityname',
        'Der Stadtname darf nur Buchstaben, Bindestriche und einen Punkt enthalten. Bitte prüfen Sie Ihre Angabe. ' +
        'Bei Schwierigkeiten helfen wir gerne telefonisch weiter.',
        value => (value).match(/^[A-Za-z-()./ À-ÖØ-öø-ÿ]*$/),
    )
    .min(2, 'Ein Stadtname besteht aus mindestens 2 Zeichen.')
    .max(32, 'Ein Stadtname besteht aus maximal 32 Zeichen.')
    .required(requiredMessage);

export const houseNumberSchema = requiredMessage => yup.string()
    .test(
        'is-valid-housenumber',
        "Die Hausnummer muss mit einer Zahl beginnen und darf maximal 9 Zeichen enthalten. Erlaubt sind Zahlen, Buchstaben, Leerzeichen, '-', und '/'. " +
        "Die Hausnummer darf nicht nur aus '0' bestehen.",
        value => (value).match(/^(?!^0$)[A-Za-z0-9 /-]{1,9}$/),
    )
    .max(9, 'Eine Hausnummer besteht aus maximal 9 Zeichen.')
    .required(requiredMessage);

export const streetNameSchema = requiredMessage => yup.string()
    .test(
        'is-valid-streetname',
        'Der Straßenname darf nur Buchstaben, Ziffern, Leerzeichen, Bindestriche, Schrägstriche und Punkte enthalten. Bitte prüfen Sie Ihre Angabe. ' +
        'Bei Fragen oder Problemen helfen wir Ihnen gerne telefonisch weiter.',
        value => (value).match(/^[.A-Za-z0-9\- /À-ÖØ-öø-ÿ]+$/),
    )
    .min(2, 'Ein Straßenname besteht aus mindestens 2 Zeichen.')
    .max(60, 'Ein Straßenname besteht aus maximal 60 Zeichen.')
    .required(requiredMessage);
